import { useActiveBlockingAlarm } from './useActiveBlockingAlarm';

export const useIsSilentMode = () => !!useActiveBlockingAlarm();
